<template>
    <div>
        <template v-if="log_shipping === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Log Shipping </h1>
                <router-link to="/addlogshippingComponent" class="btn btn-primary active float-right"> Add New</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" companyName="" />
                </div>
            </div>
            <table id="log_shipping_table" class="table" width="100%">
                <thead>
                <tr>
                    <th>Table Name</th>
                    <th>Date</th>
                    <th>Retention Days</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th class="text-center">Action</th>
                </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="log_shipping === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="log_shipping === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                pageView: null,
                log_shipping: null,
                logShippingTable: null,
            };
        },
        methods: {
            callDataTable(){
                var logShippingTable = $('#log_shipping_table').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    searching: true,
                    ajax: {
                        "url": "api/logShipping",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                    },
                    deferRender: true,
                    order: [[1, "asc"]],
                    columns: [
                        {data: 'table_name'},
                        {data: 'day_of_month'},
                        {data: 'retention_days'},
                        {data: 'status'},
                        {data: 'created_at',
                        render: function(data,type,full){
                                if(full.created_at != null){
                                    return moment(full.created_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {data: 'updated_at',
                            render: function(data,type,full){
                                if(full.updated_at != null){
                                    return moment(full.updated_at).format('YYYY-MM-DD');
                                }else{
                                    return "---";
                                }
                            }},
                        {
                            data: 'id',
                            sorting: false,
                            render: function(data, type, full) {
                                var editUrl = '/editlogshippingComponent/' + full['id'];
                                var editAction = '<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' + editUrl + '\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                                var deleteAction = '<a onclick="VueComponents.logshippingComponent.methods.deleteLog('+full['id']+')"  class="action delete"><i class="fas fa-trash"></i></a>';
                                return editAction + deleteAction;
                            }
                        }
                    ],
                    "order": [[1, "asc"]],
                    "initComplete": this.$Progress.finish()
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        logShippingTable.search(this.value).draw();
                    }
                });
            },
            deleteLog(id) {
                gThat.$Progress.start();
                swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this log!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        $.ajax({
                            url: "/api/logShipping/" + id,
                            type: "DELETE",
                            success: function (res) {
                                if (res.code == 200) {
                                    gThat.$Progress.finish();
                                    gThat.showAlertBox('success', 'Log deleted successfully.');
                                    $('#log_shipping_table').DataTable().ajax.reload();
                                } else {
                                    gThat.showToastBox('error', 'System is not responding! Please try again later.');
                                }
                            },
                            error: function (err) {
                                console.log(err);
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error', 'System is not responding! Please try again later.');
                            }
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        );
                    }
                });
            },

        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('log_shipping').then(result => {
                if(result.log_shipping == true)
                {
                    this.log_shipping = true;
                } else {
                    this.log_shipping = false;
                }
            }).then(result => {
                if(this.log_shipping == true){
                    this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
